import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppAdminModule} from './app/app-admin.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppAdminModule);



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/main.ts